import React from 'react';
import './WhereWeWork.css';
// import './HealthServices.css';
import afgMap from '../images/slider1_health.jpg';

const HealthServices: React.FC = () => {
  const scopeOfWork = [
    {
      title: 'Health Services',
      description: 'Providing inclusive and sustainable health services to ensure equal access to healthcare for all Afghans.',
      icon: 'fas fa-heartbeat' // Changed to a health-related icon
    }
  ];

  return (
    <div className="where-we-work-page">

      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2>Our Integrated Approach to Health Services</h2>
            <p>NORA operates across all 34 provinces of Afghanistan through experienced and dedicated health teams</p>
          </div>
          
          <div className="clean-map-container">
            <img 
              src={afgMap} 
              alt="Afghanistan Map - NORA Health Services Coverage" 
              className="clean-afghanistan-map"
            />
          </div>
        </div>
      </section>

      {/* Scope of Work Section */}
      <section className="scope-work-section">
        <div className="container">
          <div className="scope-cards-grid">
            {scopeOfWork.map((item, index) => (
              <div key={index} className="scope-card">
                <div className="scope-card-header">
                  <i className={item.icon}></i>
                  <h3><strong>Our Integrated Approach to Health Services</strong></h3>
                </div>
                <p className="scope-card-description">
                  <strong>Community health is the essential foundation of sustainable development.</strong> 
                  <br/><br/>
                  In Afghanistan, many people still lack access to quality healthcare due to economic constraints, poverty, difficult access to medical centers, and shortage of skilled health professionals. This inequality not only threatens individual health but also directly impacts education, employment, and the country's economic growth.
                  <br/><br/>
                  <strong>Our institute is dedicated to providing inclusive and sustainable health services that address critical community needs and ensure equal access to healthcare for all.</strong> We focus on building resilient health systems that serve the most vulnerable populations.
                  <br/><br/>
                  <strong><h3>Our integrated health initiatives include:</h3></strong>
                  <br/><br/>
                  <strong>1. Primary Healthcare Delivery:</strong> Providing comprehensive medical and healthcare services in remote, underserved, and hard-to-reach areas where healthcare infrastructure is limited or non-existent.
                  <br/><br/>
                  <strong>2. Healthcare Infrastructure Support:</strong> Equipping provincial hospitals and local clinics with essential medical supplies, medicines, and equipment to enhance healthcare capacity and improve service quality across Afghanistan.
                  <br/><br/>
                  <strong>3. Community Health Education:</strong> Implementing extensive awareness programs to educate families and communities on disease prevention, environmental health, proper nutrition, and healthy lifestyle practices.
                  <br/><br/>
                  <strong>4. Healthcare Professional Development:</strong> Empowering local healthcare staff through specialized training, capacity-building workshops, and continuous professional development to ensure delivery of high-quality, evidence-based services.
                  <br/><br/>
                  <strong>5. Specialized Care Programs:</strong> Implementing targeted initiatives for maternal and child health, vaccination campaigns, and primary care services specifically designed for vulnerable and marginalized groups.
                  <br/><br/>
                  <strong>6. Health Monitoring & Data Systems:</strong> Establishing robust community health monitoring mechanisms and collecting accurate epidemiological data to inform evidence-based planning and enable continuous improvement of health services.
                  <br/><br/>
                  <strong>7. Medication & Supply Distribution:</strong> Ensuring consistent availability and distribution of essential medicines and medical supplies to healthcare facilities, with particular attention to chronic disease management and emergency care needs.
                  <br/><br/>
                  <strong>Our Goal:</strong> To build a healthy, empowered, and sustainable community where no Afghan is deprived of essential healthcare due to geographic isolation, economic limitations, or social barriers. We strive for a future where every individual has access to quality health services as a fundamental right.
                  <br/><br/>
                  <strong>A Call for Partnership</strong>
                  <br/><br/>
                  We invite domestic and international donors and organizations to support these vital health programs financially, technically, and strategically. Your partnership is crucial to expanding our reach, strengthening healthcare infrastructure, and creating sustainable health systems. Through joint collaboration, we can elevate Afghan community health to international standards and create a healthier, more prosperous future for all Afghans.
                  <br/><br/>
                  <strong>Your participation can transform lives and build the foundation for a healthier Afghanistan.</strong>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default HealthServices;